import PackageRateList from './PackageRateList'

export default PackageRateList